import angular from 'angular';

angular.module('ib-web-ancillaries-module', [
    'pascalprecht.translate',
    'LocalStorageModule',
    'ngCookies',
    'infinite-scroll',
    'ib-baggages-box-module',
    'ib-baggage-module',
    'ib-box-warning-module',
    'ib-bundeling-module',
    'ib-speqs-box-module',
    'ib-speqs-module',
    'ib-commons-utils-module',
    'ib-commons-constants-module',
    'ib-commons-cookies-service-module',
    'ib-commons-proxies-module',
    'ib-web-ancillaries-services-module',
    'ib-accordion-module',
    'ib-alert-notification-module',
    'ib-ancillaries-components',
    'ib-gastronomic-proposal-component',
    'ib-bids-footer-module',
    'ib-bids-slider-module',
    'ib-bids-box-module',
    'ib-upgrading-bids-module',
    'ib-header-steps-bids-module',
    'ib-bob-module',
    'ib-breakdown-ancillaries-module',
    'ib-dates-module',
    'ib-carbon-footprint-box-module',
    'ib-carbon-footprint',
    'ib-insurance-module',
    'ib-insurance-box-module',
    'ib-meals-box-module',
    'ib-special-meals-module',
    'ib-scroll-passenger-special-meal-module',
    'ib-ancillaries-modal-module',
    'ib-onrequest-flexibilization-module',
    'ib-priority-boarding-module',
    'ib-scroll-list-module',
    'ib-seat-map-module',
    'ib-new-seat-map-module',
    'ib-seat-map-box-module',
    'ib-select',
    'ib-ancillaries-banner',
    'ib-seat-map-info-box-module',
    'ib-route-passengers-info-module',
    'ib-route-segment-passengers-info-module',
    'ib-globick-transfers-box-module',
    'ib-globick-transfers-module',
    'ib-globick-activities-box-module',
    'ib-globick-activities-module',
    'ib-insurance-allianz-fusion-module',
    'ib-insurance-allianz-fusion-box-module'
]);
